// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InvoiceListItem_inv__ZgeV1 {
  width: 38rem;
  display: grid;
  grid-template-columns: 1.8fr 1fr;
  gap: 2rem;
  box-sizing: border-box;
  border-radius: 1rem;
  background-color: var(--color-primary-3);
  padding: 1rem 2rem;
  position: relative;
  margin-bottom: 2rem;
}
.InvoiceListItem_inv__expand__an9oQ {
  position: absolute;
  right: 2rem;
  bottom: 1rem;
  cursor: pointer;
}
.InvoiceListItem_inv__expand__an9oQ:hover {
  color: var(--color-primary);
}
.InvoiceListItem_inv__main__bbGZz {
  font-weight: 700;
  color: var(--color-primary-4);
}
.InvoiceListItem_inv__other__bQANz {
  color: var(--color-primary-4);
  font-size: 1.4rem;
}

.InvoiceListItem_item__XyCU2 {
  display: grid;
  grid-template-columns: 1.3fr 1fr;
  gap: 2rem;
  margin-bottom: 1rem;
}
.InvoiceListItem_item__qty__DQ42Q {
  font-size: var(--default-font-small);
}
.InvoiceListItem_item__total__hoG2L {
  font-weight: 700;
  color: var(--color-primary);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Components/InvoiceListItem.module.scss"],"names":[],"mappings":"AAAA;EACC,YAAA;EACA,aAAA;EACA,gCAAA;EACA,SAAA;EAEA,sBAAA;EACA,mBAAA;EACA,wCAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AAAD;AAEC;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AAAF;AAEE;EACC,2BAAA;AAAH;AAIC;EACC,gBAAA;EACA,6BAAA;AAFF;AAKC;EACC,6BAAA;EACA,iBAAA;AAHF;;AAOA;EACC,aAAA;EACA,gCAAA;EACA,SAAA;EACA,mBAAA;AAJD;AAMC;EACC,oCAAA;AAJF;AAOC;EACC,gBAAA;EACA,2BAAA;AALF","sourcesContent":[".inv {\n\twidth: 38rem;\n\tdisplay: grid;\n\tgrid-template-columns: 1.8fr 1fr;\n\tgap: 2rem;\n\n\tbox-sizing: border-box;\n\tborder-radius: 1rem;\n\tbackground-color: var(--color-primary-3);\n\tpadding: 1rem 2rem;\n\tposition: relative;\n\tmargin-bottom: 2rem;\n\n\t&__expand {\n\t\tposition: absolute;\n\t\tright: 2rem;\n\t\tbottom: 1rem;\n\t\tcursor: pointer;\n\n\t\t&:hover {\n\t\t\tcolor: var(--color-primary);\n\t\t}\n\t}\n\n\t&__main {\n\t\tfont-weight: 700;\n\t\tcolor: var(--color-primary-4);\n\t}\n\n\t&__other {\n\t\tcolor: var(--color-primary-4);\n\t\tfont-size: 1.4rem;\n\t}\n}\n\n.item {\n\tdisplay: grid;\n\tgrid-template-columns: 1.3fr 1fr;\n\tgap: 2rem;\n\tmargin-bottom: 1rem;\n\n\t&__qty {\n\t\tfont-size: var(--default-font-small);\n\t}\n\n\t&__total {\n\t\tfont-weight: 700;\n\t\tcolor: var(--color-primary);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inv": `InvoiceListItem_inv__ZgeV1`,
	"inv__expand": `InvoiceListItem_inv__expand__an9oQ`,
	"inv__main": `InvoiceListItem_inv__main__bbGZz`,
	"inv__other": `InvoiceListItem_inv__other__bQANz`,
	"item": `InvoiceListItem_item__XyCU2`,
	"item__qty": `InvoiceListItem_item__qty__DQ42Q`,
	"item__total": `InvoiceListItem_item__total__hoG2L`
};
export default ___CSS_LOADER_EXPORT___;
